import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_SERVER,
});

const token = localStorage.getItem('@TrenzoX:token');
const activeGymId = localStorage.getItem('@TrenzoX:activeGymId');

api.defaults.headers.common.Authorization = `Bearer ${token}`;

if (activeGymId) {
  api.defaults.headers.common['x-gym-id'] = activeGymId;
}

// Essas duas mensagens são as únicas que `ensureAuthenticated` (backend)
// lança com status 401 -- esse status é reaproveitado por vários outros
// erros de negócio (email já cadastrado, idade mínima, etc), então não
// dá pra tratar "401 = sessão expirada" só pelo status, tem que casar a
// mensagem também.
const JWT_ERROR_MESSAGES = ['JWT token is missing', 'Invalid JWT token'];

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;

    if (status === 401 && JWT_ERROR_MESSAGES.includes(message)) {
      const refreshToken = localStorage.getItem('@TrenzoX:refreshToken');

      if (refreshToken) {
        api
          .post('session/logout', { refresh_token: refreshToken })
          .catch(() => {
            // best-effort -- a sessão local já vai ser limpa de qualquer
            // forma, e o registro no servidor expira sozinho se essa
            // chamada falhar
          });
      }

      localStorage.removeItem('@TrenzoX:token');
      localStorage.removeItem('@TrenzoX:user');
      localStorage.removeItem('@TrenzoX:activeGymId');
      localStorage.removeItem('@TrenzoX:viewMode');
      localStorage.removeItem('@TrenzoX:refreshToken');

      // Redirect "duro" (não via react-router) de propósito -- o
      // interceptor roda fora de qualquer componente, sem acesso a
      // `useNavigate`/`useAuth`. O reload garante que todo estado do
      // app (inclusive o AuthContext) reinicia do zero já deslogado.
      window.location.href = '/sign-in?session_expired=1';

      return Promise.reject(error);
    }

    if (status === 403) {
      // TODO
      /**
       * transformar o service em um hook para usar o toast aqui (é viavel?)
       */
    }

    return Promise.reject(error);
  },
);

export { api };
